import React from 'react'
import { useTranslation } from 'react-i18next'
import { Theme } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'
import { Button, Grid, Paper } from '@mui/material'
import Stack from 'ui/layout/Stack'
import Modal from 'ui/layout/Modal'
import MarginRightCancelButton from 'ui/shorthands/MarginRightCancelButton'
import { Text1 } from 'ui/shorthands/Texts'

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    letterSpacing: '0.5px',
  },
  amount: {
    fontSize: 24,
    fontWeight: 'bold',
    letterSpacing: '3.5px',
  },
}))

const ConfirmModal: React.FC<{
  open: boolean
  amount: number
  onCancel: () => void
  onSubmit: () => void
  submitDisabled: boolean
  submitLabel: string
}> = ({ open, amount, onCancel, onSubmit, submitDisabled, submitLabel }) => {
  const { t } = useTranslation()
  const { classes } = useStyles()
  return (
    <Modal large open={open} handleClose={() => onCancel()}>
      <Paper className={classes.root}>
        <Stack>
          <Text1>
            {t('下記の金額を請求します。よろしければ送信してください。')}
          </Text1>
        </Stack>
        <Stack>
          <Grid container alignItems={'center'}>
            <Grid item xs={4}>
              <Text1>{t('請求金額')}</Text1>
            </Grid>
            <Grid item>
              <span className={classes.amount}>
                {Number(amount).toLocaleString('ja')}
                {t('円')}
              </span>
            </Grid>
          </Grid>
        </Stack>
        <Stack align="right">
          <MarginRightCancelButton onClick={() => onCancel()} />
          <Button
            color="primary"
            variant="contained"
            type="submit"
            onClick={() => onSubmit()}
            disabled={submitDisabled}
          >
            {submitLabel}
          </Button>
        </Stack>
      </Paper>
    </Modal>
  )
}

export default ConfirmModal
